import { state } from '../map_state/state'
import { Renderer } from '../renderer'
import { callMethodOnKeydown, isTyping } from '../helpers'
import { addSensorTool } from './add_sensor_tool'

class SettingsTool {
  constructor () {
    this.element = document.getElementById('mct-settings')
    this.menu = document.getElementById('mct-settings-menu')
    state.visibleRSSI = this.menu.querySelector(".mct-setting input[name='visibleRSSI']").checked
    this.bindEvents()
  }

  bindEvents () {
    this.onKeyDown = this.onKeyDown.bind(this)
    this.toggleMenu = this.toggleMenu.bind(this)
    this.element.addEventListener('click', this.toggleMenu)
    document.addEventListener('keydown', this.onKeyDown)
    this.menu.querySelectorAll('.mct-visibility-settings').forEach(checkbox => checkbox.addEventListener('change', this.toggleVisibility))
  }

  unBindEvents () {
    this.element.removeEventListener('click', this.toggleMenu)
    document.removeEventListener('keydown', this.onKeyDown)
    this.menu.querySelectorAll('.mct-visibility-settings').forEach(checkbox => checkbox.removeEventListener('change', this.toggleVisibility))
  }

  onKeyDown (e) {
    if (isTyping(e.target)) return
    if (e.key === '0') callMethodOnKeydown(e.target, this.toggleMenu)
  }

  toggleMenu () {
    const selected = this.element.classList.contains('selected')
    this.element.classList.toggle('selected')
    this.menu.classList.toggle('hidden', selected)
  }

  toggleVisibility (event) {
    const target = event.currentTarget
    const name = target.getAttribute('name')
    state[name] = target.checked
    if (name === 'visibleRSSI') {
      addSensorTool.syncVisibleRSSI()
      Renderer.render()
      return
    }
    Renderer.render()
  }
}

export let settingsTool = null

export function initSettingsTool () {
  settingsTool = new SettingsTool()
  return settingsTool
}
